export default __webpack_public_path__ + "static/media/dewpoint.c8d87d78.svg";